
  import { Component, Vue } from 'vue-property-decorator'

  @Component
  export default class CountStatuses extends Vue {
    mounted() {
    }
  }
